/* eslint-disable import/extensions */

// Services Img Imports
import Web from '../assets/images/Services/1.png';
import Mobile from '../assets/images/Services/2.png';
import UIUX from '../assets/images/Services/3.png';

// Portfolio Img Imports
import ColossalK from '../assets/images/Portfolio/ColossalK.png';
import FoliarelOK from '../assets/images/Portfolio/FoliarelOK.png';
import Mantus from '../assets/images/Portfolio/Mantus.png';
import NIXI from '../assets/images/Portfolio/NIXI.png';
import Turan from '../assets/images/Portfolio/turan.png';
import Primer from '../assets/images/Portfolio/Primer.png';
import Adesivor from '../assets/images/Portfolio/Adesivor.png';

// Advantages
import ProdukBerkualitas from '../assets/images/Advantages/Communicative.png';
import ProdukTeruji from '../assets/images/Advantages/Collaborative.png';
import HargaTerjangkau from '../assets/images/Advantages/Management.png';
import Favorite from '../assets/images/Advantages/Favorite.png';

// Testimonials
import Dadang from '../assets/images/Testimonials/Dadang.PNG';
import Mamuri from '../assets/images/Testimonials/Mamuri.png';
import Amin from '../assets/images/Testimonials/Amin.PNG';

export const Services = [
  {
    title: 'Pupuk dan Nutrisi Tanaman Terbaik',
    imageUrl: Web,
    animation: 'left',
  },
  {
    title: 'Konsultasi Pertanian',
    imageUrl: Mobile,
    animation: 'up',
  },
  {
    title: 'Pemberdayaan Petani dan Komunitas',
    imageUrl: UIUX,
    animation: 'right',
  },
];

export const Portfolios = [
  {
    id: 'asd1293uasdads1',
    title: 'Colossal-K',
    imageUrl: ColossalK,
    type: 'Pupuk',
    responsibility: [
      'Pupuk',
    ],
  },
  {
    id: 'asd1293uhjkhkjh2',
    title: 'Foliarel OK',
    imageUrl: FoliarelOK,
    type: 'Pupuk',
    responsibility: [
      'Pupuk',
    ],
  },
  {
    id: 'asd1293uvbvcbbd3',
    title: 'Mantus',
    imageUrl: Mantus,
    type: 'Nutrisi Tanaman',
    responsibility: [
      'Nutrisi Tanaman',
    ],
  },
  {
    id: 'asd1293ufgdfgs4',
    title: 'NIXI',
    imageUrl: NIXI,
    type: 'Lainnya',
    responsibility: [
      'Lainnya',
    ],
  },
  {
    id: 'asd1293ulskmnb5',
    title: 'Turan',
    imageUrl: Turan,
    type: 'Pupuk',
    responsibility: [
      'Pupuk',
    ],
  },
  {
    id: 'asd1293primer6',
    title: 'Primer',
    imageUrl: Primer,
    type: 'Lainnya',
    responsibility: [
      'Lainnya',
    ],
  },
  {
    id: 'asd1293adesivor7',
    title: 'Adesivo',
    imageUrl: Adesivor,
    type: 'Lainnya',
    responsibility: [
      'Lainnya',
    ],
  },
];

export const Advantages = [
  [{
    title: 'Produk Berkualitas Tinggi',
    description: 'Kami menghadirkan produk pupuk berkualitas tinggi yang dirancang untuk meningkatkan hasil panen sekaligus menjaga keseimbangan ekosistem',
    imageUrl: ProdukBerkualitas,
  },
  {
    title: 'Harga Terjangkau',
    description: 'Berkomitmen untuk menyediakan produk dengan harga terjangkau sebagai solusi terbaik bagi para petani, agribisnis, dan masyarakat yang peduli terhadap masa depan pertanian Indonesia',
    imageUrl: HargaTerjangkau,
  }],
  [{
    title: 'Produk Teruji​',
    description: 'Produk kami telah dirancang khusus untuk memenuhi kebutuhan berbagai jenis tanaman, dan sudah teruji kualitasnya.',
    imageUrl: ProdukTeruji,
  },
  {
    title: 'Favorit Para Petani',
    description: "Para petani telah mencoba produk kami, dan semua klien kami sangat menyukainya.",
    imageUrl: Favorite,
  }],
];
export const Testimonials = [
  {
    id: 1,
    name: 'Dadang',
    company: 'Petani',
    testimoni: 'Saya menanam padi dari awal umur satu minggu pakai produk NIXI. Dan, alhamdulillah bagus terus anakan juga banyak, daun juga bisa lebar, lalu ketinggian juga maksimal bisa tinggi. Baguslah istilahnya bagus dibanding dengan produk yang lain bisa menjamin ininya akas dan anakan juga banyak.',
    imageUrl: Dadang,
  },
  {
    id: 2,
    name: 'Amin',
    company: 'Petani',
    testimoni: 'Saya sudah menggunakan mantus, saat aplikasi umur sepuluh hari dan umur dua puluh hari. untuk nixinya tiga kali boleh dilihat hasilnya. Alhamdulillah di daun untuk yang saya rasakan itu untuk mantusnya itu di daun bisa tebel, terus atas di daun akas daun bisa tebel, daunnya jadi tidak lemes ya.',
    imageUrl: Amin,
  },
  {
    id: 3,
    name: 'Mamuri',
    company: 'Petani',
    testimoni: 'Setelah saya pakai nixi dan mantus. Dari dinding sel itu kelihatan tebel-tebel tapi lentur. Jadi kalau kita mau siram apa gak khawatir daunnya tuh pada patah. kelebihan yang kedua itu biasanya kan kalau kita pakai nutrisi itu kan bisa membunuh pestisida yang lain. Nah, setelah saya coba pakai, biarpun saya langsung campur juga yang lainnya, semua itu mempan semua.',
    imageUrl: Mamuri,
  },
];
